import { ErrorBlock } from 'components/ErrorBlock'
import { Spinner, SpinnerProps } from 'components/Spinner'
import { compact } from 'utils'
import React, { FC, ReactNode } from 'react'
import { UseQueryResult } from 'react-query'
import styled, { css } from 'styled-components'

export const asyncStyles = css`
	height: 100%;
	width: 100%;
	position: relative;
`

const AsyncView = styled.div`
	${asyncStyles}
`
type FetchResults = Pick<UseQueryResult<any>, 'isLoading' | 'error' | 'isSuccess' | 'data'>

const NotFound = () => <div className='async-not-found'>Not Found...</div>

export type AsyncProps = {
	fetchResults: FetchResults | Array<FetchResults>
	loader?: ReactNode
	className?: string
	isScreen?: boolean
	freezeLoader?: boolean // freezes loading state for debugging/styling
	hideErrors?: boolean // for small components where we don't want to display error blocks
	children?: ReactNode
	Page404?: (() => JSX.Element) | FC<any>
	loaderType?: SpinnerProps['type']
}
export const Async = ({
	fetchResults,
	className,
	loader: loaderOverride,
	loaderType,
	isScreen,
	freezeLoader,
	children,
	hideErrors,
	Page404,
}: AsyncProps) => {
	const resultsArry = Array.isArray(fetchResults) ? fetchResults : [fetchResults]

	const isLoading = resultsArry.map(({ isLoading }) => isLoading).some(Boolean)
	const errors = compact(resultsArry.map(({ error }) => error))
	const loader = loaderOverride || (
		<Spinner
			height={isScreen ? 'full' : 'lg'}
			isOverlay={!isScreen}
			type={loaderType || (isScreen ? 'circle' : 'dots')}
		/>
	)

	// const error = errors.length && (errors[0] as any)
	const results = resultsArry.length === 1 && resultsArry[0]
	const is204 = results ? results.isSuccess && !results.data : false
	const hasData = resultsArry.some(({ data }) => !!data)

	const NotFoundComponent = Page404 || NotFound

	return isScreen && is204 ? (
		<NotFoundComponent />
	) : (
		<AsyncView className={`async${className ? ` ${className}` : ''}`}>
			{isLoading || freezeLoader ? (
				loader
			) : hasData ? (
				children
			) : errors?.length && !hideErrors ? (
				<ErrorBlock error={errors as Error[]} />
			) : (
				children
			)}
		</AsyncView>
	)
}
